<template>
  <v-container>
    <div class="breadcrumb-wrap">
      <v-breadcrumbs :items="breadcrumbs" />
    </div>
    <div class="form-npa private-pg">
      <div class="position">
        <div class="bg-white p-20">
          <div class="form-head">
            <Widget position="menu_profile" />
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                        dark
                        v-on="on"
                        class="navbar-toggler-profile"
                        :aria-label="$t('Открыть меню профиля')"
                >
                  {{ $t("Профиль") }} <span class="caret" aria-hidden="true"></span>
                </v-btn>
              </template>
              <v-list class="navbar-collapse">
                <v-list-item>
                  <Widget position="menu_profile" />
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div class="form-body">
            <div class="private-section" v-if="user && user.developer">
              <div class="moderate-mode">
                <label>{{ $t("Режим модерации комментариев") }}:</label>
                <div class="radio">
                  <v-radio-group
                    v-model="settings.settingCommentMod"
                    :aria-label="$t('Режим модерации комментариев')"
                  >
                    <v-radio label="Включить" :value="true" />
                    <v-radio label="Выключить" :value="false" />
                  </v-radio-group>
                </div>
              </div>
              <div
                class="moderate-mode col-day"
                :class="{
                  invalid:
                    $v.settings.settingCountDayReview.$dirty &&
                    !$v.settings.settingCountDayReview.required
                }"
              >
                <label>{{ $t("Количество дней при рассмотрении") }}</label>
                <input
                  id="settingCountDayReview"
                  type="number"
                  v-model="settings.settingCountDayReview"
                  :aria-label="$t('Количество дней при рассмотрении')"
                  :aria-invalid="$v.settings.settingCountDayReview.$dirty && !$v.settings.settingCountDayReview.required ? 'true' : 'false'"
                  @input="$v.settings.settingCountDayReview.$touch()"
                  @blur="$v.settings.settingCountDayReview.$touch()"
                />
              </div>
              <div class="moderate-mode moderate-btn">
                <v-btn color="primary" @click="save">{{ $t("Сохранить") }}</v-btn>
                <v-btn @click="cancel">{{ $t("Отмена") }}</v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import Widget from '@/components/app/Widget'
import User from '@/model/user'
import { mapState } from 'vuex'
import { mapMutations } from 'vuex'
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import {Trans} from "@/plugins/Translation"

export default {
  components: {
    Widget
  },
  data: () => ({
    settings: {
      settingCommentMod: null,
      settingCountDayReview: null
    },
    breadcrumbs: [
      { text: 'Профиль', disabled: false, href: Trans.currentLocaleUrl + '/profile' },
      { text: 'Настройки', disabled: true }
    ]
  }),
  validations: {
    settings: {
      settingCommentMod: { required },
      settingCountDayReview: { required }
    }
  },
  computed: mapState({
    user: (state) => {
      if (!state.user.user) {
        this.checkUser()
      }

      return state.user.user
    }
  }),
  watch: {
    user() {
      if (this.user && this.user.developer) {
        this.settings.settingCommentMod = this.user.developer.setting_comment_mod
        this.settings.settingCountDayReview = this.user.developer.setting_count_day_review
      }
    }
  },
  created() {
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    ...mapActions(['checkUser']),
    save() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.setLoading(true)

      User.updateDeveloperSettings({
        developer_setting: this.settings
      }).then((response) => {
        this.user = response.data.user
        this.setLoading(false)
      })
    },
    cancel() {
      if (this.user && this.user.developer) {
        this.settings.settingCommentMod = this.user.developer.setting_comment_mod
        this.settings.settingCountDayReview = this.user.developer.setting_count_day_review
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  },
  mounted() {
    this.cancel()
  }
}
</script>

<style lang="scss" scoped>
.setting-pg {
  .v-btn {
    margin-right: 15px;
  }
}
.moderate-mode {
  label {
    padding-right: 20px;
    text-decoration: none;
  }
  .v-input--radio-group__input {
    flex-direction: row !important;
  }
}
.col-day {
  margin-bottom: 30px;
  input {
    max-width: 200px;
  }
}
</style>
